<template lang="pug">
modal#delete-envelope-modal.text-center(
  :buttonColor='buttonColor'
  :close-button-label='$t("modal.deleteEnvelope.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.deleteEnvelope.processButtonLabel")'
  :title='$t("modal.deleteEnvelope.title")'
  @process='deleteEnvelope'
  processButtonClass='btn-danger'
  ref='modal'
  size='sm'
)
  .text-start {{ $t('modal.deleteEnvelope.message1') }}
    |
    | {{ $t('modal.deleteEnvelope.message2') }}
  img.mt-4.mb-3(
    alt='draft-delete-warning'
    src='/img/ilustrations/draft-delete-warning.svg'
  )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import alert from '@/modules/account/common/alert';

export default {
  name: 'DeleteEnvelopeModal',
  props: {
    envelopeId: [Number, String],
  },
  components: {
    Modal,
    ImageLoader,
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
    };
  },
  methods: {
    deleteEnvelope() {
      this.loading = true;
      EnvelopesService.deleteEnvelope(this.envelopeId)
        .then(() => {
          this.$emit('refresh');
          this.loading = false;
          this.$refs.modal.close();
          alert.fireAlert(this.$t('alert.envelopeDeletedSuccess'), {
            styles:
              'background-color: #D4EDDA; border: solid 1px #AACFB3; color: #0F6642;',
            icon: 'circle-check',
          });
        })
        .catch(() => {
          alert.fireAlert(this.$t('alert.envelopeDeleteError'), {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
            icon: 'triangle-exclamation',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
